import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DownloadStateService {
    private downloadingStates = new Map<string, BehaviorSubject<boolean>>();

    setDownloading(offerId: string): void {
        if (!this.downloadingStates.has(offerId)) {
            this.downloadingStates.set(offerId, new BehaviorSubject<boolean>(false));
        }
        this.downloadingStates.get(offerId)!.next(true);
    }

    isDownloading(offerId: string): Observable<boolean> {
        if (!this.downloadingStates.has(offerId)) {
            this.downloadingStates.set(offerId, new BehaviorSubject<boolean>(false));
        }
        return this.downloadingStates.get(offerId)!.asObservable();
    }

    cleanup(offerId: string): void {
        const subject = this.downloadingStates.get(offerId);
        if (subject) {
            subject.complete();
            this.downloadingStates.delete(offerId);
        }
    }
}
